type Color = [number, number, number];

export const RGBToHSL = (colorRgb: Color): Color => {
  let [r, g, b] = colorRgb;
  r /= 255;
  g /= 255;
  b /= 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
  return [
    60 * h < 0 ? 60 * h + 360 : 60 * h,
    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
    (100 * (2 * l - s)) / 2,
  ];
};

export const HSLToRGB = (colorHsl: Color): Color => {
  // eslint-disable-next-line prefer-const
  let [h, s, l] = colorHsl;
  s /= 100;
  l /= 100;
  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [Math.round(255 * f(0)), Math.round(255 * f(8)), Math.round(255 * f(4))];
};

const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
};

export const strToColor = (color: string): Color | null => {
  const match = color.match(/^#([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])/i);
  if (match) {
    return [parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16)];
  }
  return null;
};

export const colorToStr = (color: Color): string => {
  const [r, g, b] = color;

  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
    return '';
  }

  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};
